import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import {
  IntegrationsAction,
  IntegrationsState,
} from '@modules/integrationsV2/store/types';

export function integrationsReducer(
  state: IntegrationsState,
  action: IntegrationsAction,
): IntegrationsState {
  switch (action.type) {
    case IntegrationsActionType.SET_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }

    case IntegrationsActionType.SET_VIEW: {
      return {
        ...state,
        view: {
          ...state.view,
          selectedIntegrationToConnect:
            action.payload.isAddDrawerOpen === false
              ? null
              : state.view.selectedIntegrationToConnect,
          integrationTypeFilterInDrawer:
            action.payload.isAddDrawerOpen === false
              ? 'all'
              : state.view.integrationTypeFilterInDrawer,
          ...action.payload,
        },
      };
    }

    default:
      return state;
  }
}
